import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Calendar, User, ArrowLeft, ArrowRight } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import BlogHeader from './BlogHeader';
import { blogPosts } from '../data/blogPosts';
import './BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Find post in generated blog posts data
    const foundPost = blogPosts.find(p => p.slug === slug);
    
    if (foundPost) {
      setPost(foundPost);
      setError(null);
    } else {
      setError('Post not found');
      setPost(null);
    }
    
    setLoading(false);
  }, [slug]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="blog-post">
        <BlogHeader />
        <div className="container">
          <div className="post-loading">
            <div className="loading-spinner"></div>
            <p>Loading post...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="blog-post">
        <BlogHeader />
        <div className="container">
          <div className="post-error">
            <h2>Post Not Found</h2>
            <p>The blog post you're looking for doesn't exist.</p>
            <Link to="/blog" className="back-to-blog">
              <ArrowLeft size={16} />
              Back to Blog
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-post">
      <BlogHeader />
      <div className="container">
        <div className="post-navigation">
          <Link to="/blog" className="back-to-blog">
            <ArrowLeft size={16} />
            Back to Blog
          </Link>
        </div>

        <article className="post-content">
          <header className="post-header">
            <div className="post-meta">
              <div className="post-date">
                <Calendar size={16} />
                <span>{formatDate(post.date)}</span>
              </div>
              <div className="post-author">
                <User size={16} />
                <span>{post.author}</span>
              </div>
            </div>

            <h1 className="post-title">{post.title}</h1>
            
            {post.excerpt && (
              <div className="post-excerpt">
                <p>{post.excerpt}</p>
              </div>
            )}
          </header>

          <div className="post-body">
            <ReactMarkdown>{post.content}</ReactMarkdown>
          </div>

          <footer className="post-footer">
            <div className="post-tags">
              <span className="tag">AI Agents</span>
              <span className="tag">No-Code</span>
              <span className="tag">Tutorial</span>
            </div>
            
            <div className="post-actions">
              <Link to="/blog" className="read-more-posts">
                <ArrowRight size={16} />
                More Posts
              </Link>
            </div>
          </footer>
        </article>
      </div>
    </div>
  );
};

export default BlogPost;
